<template>
  <div>
    <base-button icon round type="primary" class="text-nowrap zi_100" @click="modal = true">
      <span class="mdi mdi_icon mdi-24px mdi-plus"/>
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('botClients.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('botClients.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('botClients.details.name') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'name'"
                name="id"
                v-validate="modelValidations.required"
                :error="getError('name')"
                v-model="formDetails.name">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.status') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                v-model="formDetails.status"
              >
                <el-option
                  v-for="option in availableStatuses"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('botClients.details.role') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                :placeholder="$t('botClients.form.rolePlaceholder')"
                v-model="formDetails.role"
              >
                <el-option
                  v-for="option in availableRoles"
                  class="select-primary"
                  :value="option.value"
                  :label="option.value"
                  :key="option.label"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('botClients.details.cidrs') }}</label>
            <div class="col">
              <div class="form-group">
                <tags-input v-model="formDetails.cidrs"
                            :input-placeholder="$t('botClients.form.cidrPlaceholder')"
                            input-size="" tag-size="medium"></tags-input>
              </div>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('botClients.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import TagsInput from "src/components/Inputs/TagsInput.vue";
import swal from "sweetalert2";

export default {
  name: 'new-bot-client-btn',
  props: {
    municipalityId: {
      type: String,
      default: null,
    },
    operatorId: {
      type: String,
      default: null,
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  components: {
    TagsInput,
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        name: '',
        role: '',
        cidrs: ['0.0.0.0/0'],
      },
      modelValidations: {
        required: {
          required: true
        },
      },
      availableStatuses: ['active', 'suspended'],
    }
  },

  computed: {
    ...mapState({
      details: state => state.municipality_bot_client.data,
      updating: state => state.municipality_bot_client.updating,
      error: state => state.municipality_bot_client.error,
    }),
    availableRoles() {
      let existingRoles = []
      for (let i = 0; i < this.roles.length; i++) {
        if (this.roles[i].name.startsWith('bot:')) {
          // IGNORE SYSTEM-ACCOUNT ROLES
          existingRoles.push({
            value: this.roles[i].name,
            label: this.roles[i].name,
          })
        }
      }
      return existingRoles
    },
    getActionErrorDetails() {
      return this.error ? this.error : null;
    }
  },
  methods: {
    ...mapActions(['CreateMunicipalityBotClients', 'GetMunicipalityBotClients', 'GetOperatorBotClients', 'HideCreatedBotClientSecret']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        status: this.formDetails.status,
        name: this.formDetails.name,
        role: this.formDetails.role,
        cidrs: this.formDetails.cidrs,
      }
      if (this.operatorId) {
        payload.type = 'operator'
        payload.operator_id = this.operatorId
      } else {
        payload.type = 'municipality'
        payload.municipality_id = this.municipalityId
      }

      this.CreateMunicipalityBotClients(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          if (this.operatorId) {
            this.GetOperatorBotClients({operatorId: this.operatorId});
          } else {
            this.GetMunicipalityBotClients({municipalityId: this.municipalityId});
          }
          this.resetForm();
          this.$notify({
            type: 'success',
            message: this.$t('botClients.create.createdNotification', payload),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          swal({
            text: `usr:'${this.details.id}'\npwd:'${this.details.secret}'`,
            title: this.$t('botClients.create.secretDialogText'),
            confirmButtonText: this.$t('botClients.create.secretHideBtnLabel'),
            buttonsStyling: false,
            confirmButtonClass: 'btn',
            type: 'info',
          }).then(result => {
            this.HideCreatedBotClientSecret()
          });
          this.$router.push({name: 'bot-client', params: {id: this.details.id}}).catch(err => {
          });
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        name: '',
        status: this.availableStatuses[0],
        role: '',
        cidrs: ['0.0.0.0/0'],
      };

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
